import React, { useState } from 'react';
import { Contact as ContactType } from '../../types';
import './Contact.css';

interface Props {
    contact: ContactType;
}

const Contact: React.FC<Props> = ({ contact }) => {
    const [copied, setCopied] = useState(false);

    const copyEmail = () => {
        navigator.clipboard.writeText(contact.email).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="contact-wrapper">
            <div className="contact-cta-card">
                <div className="contact-cta-glow" />
                <div className="contact-cta-content">
                    <h3 className="contact-headline">Let's Build Something Together</h3>
                    <p className="contact-subline">
                        Open to Flutter roles, freelance projects, and collaborations worldwide.
                        Based in Syria — available remotely.
                    </p>
                    <a
                        href={`mailto:${contact.email}`}
                        className="contact-primary-btn"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                        Send me an email
                    </a>
                </div>
            </div>

            <div className="contact-grid">
                <div className="contact-item">
                    <div className="contact-item-icon email-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                    </div>
                    <div className="contact-item-info">
                        <span className="contact-item-label">Email</span>
                        <span className="contact-item-value">{contact.email}</span>
                    </div>
                    <button className="contact-copy-btn" onClick={copyEmail} title="Copy email">
                        {copied ? '✓' : '⧉'}
                    </button>
                </div>

                <div className="contact-item">
                    <div className="contact-item-icon phone-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                        </svg>
                    </div>
                    <div className="contact-item-info">
                        <span className="contact-item-label">Phone / WhatsApp</span>
                        <a href={`tel:${contact.phone}`} className="contact-item-value link">{contact.phone}</a>
                    </div>
                </div>

                <div className="contact-item">
                    <div className="contact-item-icon github-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
                        </svg>
                    </div>
                    <div className="contact-item-info">
                        <span className="contact-item-label">GitHub</span>
                        <a href={contact.github} target="_blank" rel="noopener noreferrer" className="contact-item-value link">
                            AliRajab12 ↗
                        </a>
                    </div>
                </div>

                <div className="contact-item">
                    <div className="contact-item-icon linktree-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/>
                            <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
                        </svg>
                    </div>
                    <div className="contact-item-info">
                        <span className="contact-item-label">All Links</span>
                        <a href={contact.linktree} target="_blank" rel="noopener noreferrer" className="contact-item-value link">
                            linktr.ee/alirajab ↗
                        </a>
                    </div>
                </div>
            </div>

            <div className="availability-bar">
                <span className="avail-dot" />
                <span>Available for remote opportunities — Flutter, Mobile & Full-Stack roles</span>
            </div>
        </div>
    );
};

export default React.memo(Contact);
